export default __webpack_public_path__ + "static/media/Scarlett_9781843629542.10c10529.jpg";